import React from 'react';
import { 
    Box, 
    Flex, 
    Heading, 
    Text, 
    Button,
} from '@chakra-ui/react';

export default function BillingInfo() {
    return (
        <Box paddingTop='1'>
            <Box background={'gray.100'} borderRadius={'md'}>
                <Flex background={'gray.300'} paddingX='4' paddingY={'1'} borderTopRadius={'md'}>
                    <Text fontSize='sm' color='gray.700' textTransform={'capitalize'} fontWeight={'semibold'}>
                        Current plan:
                    </Text>
                    <Text marginLeft={'1'} fontSize={'sm'} color='gray.500'>
                        Standard
                    </Text>
                </Flex>
                <Flex paddingX='4' alignItems={'center'} paddingY='6' justifyContent={'space-between'}> 
                    <Box>
                        <Box>
                            <Heading as='h3' size='lg'>
                                $90.00
                            </Heading>
                        </Box>
                        <Box marginTop={'1'}>
                            <Text fontSize='sm' color='gray.700' textTransform={'capitalize'} fontWeight={'semibold'}>
                                Standard (monthly)
                            </Text>
                            <Text fontSize={'sm'} color='gray.500'>
                                Your next payment is on <strong>19th August 2023</strong>
                            </Text>
                        </Box>
                    </Box>
                    <Box>
                        <Button 
                            variant='outline' 
                            size={'sm'} 
                            mr={3} 
                            color='gray.500' 
                            borderColor={'gray.600'}
                            background='whiteAlpha.700'
                        >
                            Cancel subscription
                        </Button>
                        <Button 
                            variant='solid' 
                            size={'sm'} 
                            colorScheme='blue' 
                        >
                            Upgrade
                        </Button>
                    </Box>
                </Flex>
            </Box>
        </Box>
    )
}